module.exports = __webpack_public_path__ + "static/img/mx.8d75d32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/mx.png
// module id = 9Qmd
// module chunks = 18